/*!
 * @pan-gms/comments-manager v1.0.12
 * (c) Nithin V
 * Released under the ISC License.
 */
'use strict';

//
//
//
//
//
//
var script$4 = {
  name: "headercomp",
  data: function data() {
    return {
      headerText: "Comment"
    };
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "cmt_header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.headerText))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('button', {
    staticClass: "submit"
  }, [_vm._v(_vm._s(_vm.$t('Resolve')))])], 1);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-53a5c0d8_0", {
    source: ".cmt_header{padding:10px;color:#a6a7a9}.cmt_header h3{padding:0;margin:0;font-weight:700!important;font-size:17px!important;text-align:left!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject SSR */

var headercomp = normalizeComponent_1({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, browser, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$3 = {
  name: "editor",
  props: ['resolved', 'commentWrapper'],
  methods: {
    addComment: function addComment() {
      this.$emit("save", this.commentWrapper.comment);
    },
    clearComment: function clearComment() {
      this.$emit("cancel");
    }
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "edtr_CommentDiv"
  }, [_vm.commentWrapper.editable ? _c('h3', [_vm._v(_vm._s(_vm.$t('Edit Comment:')))]) : _c('h3', [_vm._v(_vm._s(_vm.$t('New Comment')))]), _vm._v(" "), _c('div', {
    staticClass: "cmt_textArea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.commentWrapper.comment,
      expression: "commentWrapper.comment"
    }],
    attrs: {
      "name": "txtComment",
      "outlined": "",
      "disabled": _vm.resolved
    },
    domProps: {
      "value": _vm.commentWrapper.comment
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.$set(_vm.commentWrapper, "comment", $event.target.value);
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cmt_button"
  }, [!_vm.resolved ? _c('button', {
    staticClass: "submit",
    on: {
      "click": _vm.addComment
    }
  }, [_vm._v(_vm._s(_vm.$t('Submit')))]) : _vm._e(), _vm._v(" "), !_vm.resolved ? _c('button', {
    staticClass: "submit",
    staticStyle: {
      "margin-left": "10px !important"
    },
    attrs: {
      "disabled": _vm.resolved
    },
    on: {
      "click": _vm.clearComment
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]) : _vm._e()])]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-771af759_0", {
    source: ".edtr_CommentDiv{display:block;bottom:0;width:100%}.cmt_textArea{padding:10px;width:100%;display:block}.cmt_button{width:100%;display:block}.edtr_CommentDiv h3{font:14px Arial bold;font-weight:700;color:#4d4e4e;margin-top:30px;font-family:Arial!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject SSR */

var editorcomp = normalizeComponent_1({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, browser, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  name: "list",
  props: ['rights', 'user', 'resolved'],
  mounted: function mounted() {
    if (this.$refs.commentList) {
      this.$refs.commentList["scrollTop"] = this.$refs.commentList.scrollHeight;
    }
  },
  computed: {
    modifiedComments: function modifiedComments() {
      var _this = this;

      if (this.$refs.commentList) {
        setTimeout(function () {
          _this.$refs.commentList["scrollTop"] = _this.$refs.commentList.scrollHeight;
        }, 100);
      }

      return this.$parent.comments.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.auditInfo.createdDate) - new Date(b.auditInfo.createdDate);
      });
    }
  }
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "commentList",
    staticClass: "cmt_list"
  }, _vm._l(_vm.modifiedComments, function (item, i) {
    return _c('div', {
      key: i,
      staticClass: "comment_container"
    }, [_c('div', {
      staticClass: "cmt_username"
    }, [_c('span', [_vm._v(_vm._s(item.user))]), _vm._v(" "), item.auditInfo && item.auditInfo.createdById == _vm.user && !_vm.resolved ? _c('v-icon', {
      staticStyle: {
        "font-size": "20px",
        "margin-left": "3px",
        "border": "none",
        "float": "none"
      },
      attrs: {
        "title": _vm.$t('Edit')
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('edit', item);
        }
      }
    }, [_vm._v("\n                mdi-pencil-outline\n            ")]) : _vm._e()], 1), _vm._v(" |\n        "), _c('div', {
      staticClass: "cmt_date"
    }, [_vm._v(_vm._s(item.auditInfo ? _vm.$services.format.formatDateTime(item.auditInfo.createdDate) : ''))]), _vm._v(" "), _c('div', {
      staticClass: "cmt_Text"
    }, [_vm._v(_vm._s(item.Comment))])]);
  }), 0);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-1bd87142_0", {
    source: ".cmt_username{font-weight:700;font-size:13px;font-family:Arial;display:inline-block;color:#545356}.cmt_resolved{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAjBJREFUOI2NUktoE1EUPW8mSTPxk4QkTRqVaYyTBox1MgFxYRFCQVfqyoVCQYt2oYiLLBRB4gdxkyIIJVbQhStBsYrQVEgRFWwhtqlEg9Ivtkk1mmRjPtNkxoWJDlWG3MdZvPfOufdyOATryuB1C86jvQOmPd1BvbOdBYBy5uticTI1nn08Gi19XEoq+USp5cJnbncc6T25vqmyMo/GhmevR88DKCsbGPh7N8aM/p371MTNKk6lXs30XzoIoEwDgOfyuaht/97DRCZoBYzDzuqsJuuP14nnxOh1C8KDW+9amWzWtkGU6vhZrwEAJo+d9dOdp46HN3s9AQL1065jcMHFY6KYQ6Uu/X6VZVljCfBBIhHVyTadHqHOXYjMpVAQRZCGdWaBD2oYm50lEqUu3u5DZC6FXLUKgr9cxrHFRUEmaMKq1YNlNv2523QMQjt8iMx+wLdKFUpuE1Q5+32RSBSIRKFSkzHAdsHNGGHXGhBy+zD4OY1cWUSTo0R1eXVeU0gkxzc6t3IAUBLruJlO4aLXB5oiGPyUbqz9f48Kiek4MXAc33P3zrTyY4NGAx1FoSCKqua+OdG/m17L51f1ZovT6OkKNIOyVpdRqUmqYfoy8nQoE4vdpwEgN/E2bukWegx2B9tKEvPJmZfJq1f6ANToxja1lRexh21mq83k8aqGaunZk6HktXAfgAqAf90xchy/7cCh0xa/EGQcHS4AKGVX5vNTU/Hl0ZHh4sLCeyX/FzVd4qZyMzDPAAAAAElFTkSuQmCC);width:16px;height:16px;float:right}.makeResloved{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAcFJREFUOI2Nkz9IW1EYxX/JSzBSBwlFiTo8IQQ0DWIIQQcRH2KrToJiEWkJxaUOBREKcQlBUScF/+AgONVCiaVDC/4hEUTRxdimLVk6REKHTl06xfLS4d7Qm/iUnOW+x/3O98753vls3EYnMCKfTXna5bkHfLHgAFALLADPAIfFvRN4DsQBlxV5HfDc1V1Bk6wta7JQJbmEZqkEDeFZA87upWjak56p6RWHyzX8O3+dkE2KyE5WnlXy4MTWTjKazhZfpc4zwBBiJrHSdP8CNQ2+trW2/oG3QLiMvLE9q4e7DNOkcLK5mgcugBvk34nJ0sGZ1EUmms4WB17P7QMh9cvRdLbQOTrxCdAVbTFV+uerj+9/dk9GAqHxycd2mwO3rjv1cJcB3Bwuzx9dJXangVyZO8AAjoE/ufOzbw/cbt3jD3g9/kfe+uaWVtOkcLA0n7x89+YWGTA0oA84RaTu14/Tk+91DxtbPe1+r2lSOFyMp9KJ3ZcWZCfQA9CBSJiKYHDs6Qdfr7FX4VnFCyBQeokjElYtWvg/fEDEch0RjmrIa0BN5YVLKokg/FXCiZAdU8k2i8IOxDrbKV9nE7HOX9Xif2+idr9iQfv/AAAAAElFTkSuQmCC);width:16px;height:16px;cursor:pointer;float:right}.cmt_Text{font-size:13px;padding:3px 0;font-family:Arial;color:#69696d}.eachComment{width:100%;padding:10px 0 0 0}.cmt_date{color:#999;display:inline-block;width:145px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject SSR */

var commentcomp = normalizeComponent_1({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, browser, undefined);

//
var script$1 = {
  name: "popup",
  props: ['comments', 'rights', 'resolved', 'user', 'actions'],
  data: function data() {
    return {
      "selectedComment": null,
      "wrapper": {
        "editable": false,
        "comment": ''
      }
    };
  },
  methods: {
    closePopup: function closePopup() {
      this.$parent.isShowing = false;
    },
    // save the comment
    saveComment: function saveComment(comment) {
      var _this = this;

      if (this.selectedComment) {
        this.selectedComment.Comment = comment;

        if (this.actions.updateFeedback) {
          this.actions.updateFeedback(this.selectedComment._id, this.selectedComment).then(function (resp) {
            if (resp.Result === 'OK') {
              Object.assign(_this.selectedComment, resp.Record);
              _this.wrapper.comment = '';
              _this.selectedComment = null;
              _this.wrapper.editable = false;
            }
          });
        }
      } else {
        this.$emit("save", comment);
        this.wrapper.comment = '';
        this.selectedComment = null;
        this.wrapper.editable = false;
      }
    },
    clearComment: function clearComment() {
      console.log('clear comment');
      this.wrapper.comment = '';
      this.selectedComment = null;
      this.wrapeer.editable = false;
    }
  },
  components: {
    headercomp: headercomp,
    editorcomp: editorcomp,
    commentcomp: commentcomp
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "comment_ctrl_container"
  }, [_c('commentcomp', {
    attrs: {
      "rights": _vm.rights,
      "user": _vm.user,
      "resolved": _vm.resolved
    },
    on: {
      "edit": function edit(e) {
        _vm.selectedComment = e;
        _vm.wrapper.editable = true;
        _vm.wrapper.comment = e.Comment;
      },
      "resolve": function resolve(e) {
        return _vm.$emit('resolve', e);
      }
    }
  }), _vm._v(" "), _c('editorcomp', {
    attrs: {
      "commentWrapper": _vm.wrapper,
      "resolved": _vm.resolved
    },
    on: {
      "cancel": _vm.clearComment,
      "save": _vm.saveComment
    }
  })], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-6bc47c75_0", {
    source: ".closeComment{background-image:url(data:image/png;base64,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);width:20px;height:21px}.cmt_popupContainer{width:500px;height:360px;z-index:1;box-shadow:-1px 1px 20px 0 #ccc;border-radius:5px;background-color:#fff;position:absolute;border:1px solid #ccc}.cmt_popupComp{width:100%;float:left}.closeComment{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAASxJREFUOI3V0s8vA0EUB/Dvm61EKhGxxFnPQhR3sdRduIlg4+CP0rMgTkJEnR0k2r+g2whHlbi0iZ15DjJsdbpvnMQ7zc/PJPO+wL+pqbXtkTA6WPrtvbGVeHa0Eo/bubKDdwzNQKWXYRQv+2IT67tlIr4pMC/atcAOOs3Gc7FUfoDik+L0wn0nqbckTKfqiogO27XqRR/4idYTH7QXOzrP7gU/D0toHuYE81AJAwByLdoKV/cjEB/DqC0q6DcJE8FvFGdsABDFeRiQic3AFwPzygwQkSJGWzqfC9o/AygGeAPKnEo5dTYli9k/842UExzUTR+0D5SiIaE9oE/OJPQLnKzszWmtriXMhQ6X5u+6zcYjkOlyV6dPILXjg9l6qVVvibFJRie+d/6+PgAts93IMzkdyQAAAABJRU5ErkJggg==);width:20px;height:20px;position:absolute;right:6px;cursor:pointer;top:5px}.unread{position:absolute;right:45px;font-size:12px;text-decoration:underline;top:10px;cursor:pointer;color:#78adc1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject SSR */

var popup = normalizeComponent_1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, browser, undefined);

//
var script = {
  name: "comment",
  props: ['tag', 'entity', 'rowId', 'rowKey', 'section', 'sectionPart', 'rights', 'user', 'actions', 'feedbackHeader', 'options'],
  data: function data() {
    return {
      comments: [],
      menu: false
    };
  },
  components: {
    popup: popup
  },
  watch: {
    menu: {
      handler: function handler() {
        var _this = this;

        if (this.menu) {
          if (this.feedbackHeader) {
            if (this.actions && this.actions.list) {
              this.actions.list(this.feedbackHeader.FeedbackHeaderId).then(function (data) {
                _this.comments = data;
              });
            }
          } else {
            if (this.actions && this.actions.createHeader) {
              var headerObj = {
                "Entity": this.entity,
                "Resolved": false,
                "RowID": this.rowId,
                "RowKey": this.rowKey,
                "Section": this.section,
                "SectionPart": this.sectionPart
              };
              this.actions.createHeader(headerObj).then(function (data) {
                console.log(data);
              });
            }
          }
        }
      }
    }
  },
  methods: {
    // check to show the resolve button
    showResolve: function showResolve() {
      var flag = false;

      if (this.rights === 'manage' && this.feedbackHeader && !this.feedbackHeader.Resolved) {
        flag = true;
      }

      return flag;
    },
    // check to show the reoprn button
    showReopen: function showReopen() {
      if (this.rights === 'manage' && this.feedbackHeader && this.feedbackHeader.Resolved) {
        return true;
      } else {
        return false;
      }
    },
    // resolve the comment
    resolve: function resolve() {
      this.actions.resolveFeedback(this.feedbackHeader.FeedbackHeaderId);
    },
    reopen: function reopen() {
      this.actions.reopenFeedback(this.feedbackHeader.FeedbackHeaderId);
    },
    // save the comment
    onSave: function onSave(comment) {
      if (comment) {
        var commentObj = {
          "Entity": this.entity,
          "Resolved": false,
          "RowID": this.rowId,
          "RowKey": this.rowKey,
          "Section": this.section,
          "SectionPart": this.sectionPart,
          "Comment": comment
        };
        this.$emit("saveData", commentObj, this);
      }
    },
    menuClose: function menuClose() {
      this.menu = false;
      this.$forceUpdate();
    },
    // update the comment
    onUpdate: function onUpdate(comment) {
      if (comment._id) {
        this.$emit("updateComment", comment._id, comment);
      }
    }
  }
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "cmt_container"
  }, [_vm.rights == 'manage' || _vm.feedbackHeader ? _c('v-menu', {
    attrs: {
      "content-class": "cmt_menu_component",
      "close-on-content-click": false,
      "min-width": "850",
      "max-height": "360",
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "btn-message",
          attrs: {
            "ripple": false,
            "icon": "",
            "color": "#19719e"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "ripple": false
          }
        }, [_vm._v("mdi-message")]), _vm._v(" "), _vm.feedbackHeader && _vm.feedbackHeader.Count > 0 ? _c('span', {
          "class": [_vm.feedbackHeader.Count > 0 ? '' : 'hidden-warning', 'badge', 'badge-warning', 'message_count']
        }, [_vm._v(" " + _vm._s(_vm.feedbackHeader.Count) + " ")]) : _vm.feedbackHeader && _vm.feedbackHeader.Count === 0 ? _c('span', {
          "class": [_vm.feedbackHeader.AllCount > 0 ? '' : 'hidden-warning', 'badge', 'badge-warning', 'message_count2']
        }, [_vm._v(" " + _vm._s(_vm.feedbackHeader.AllCount) + " ")]) : _vm._e()], 1)];
      }
    }], null, false, 2617893458),
    model: {
      value: _vm.menu,
      callback: function callback($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "feedback-container"
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "dense": ""
    }
  }, [_c('span', {
    staticClass: "header_feedback"
  }, [_vm._v(_vm._s(_vm.$t("Comment")))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm.showResolve() ? _c('button', {
    staticClass: "submit",
    on: {
      "click": _vm.resolve
    }
  }, [_c('span', {
    staticClass: "comment_btn_icon"
  }), _vm._v("\n           " + _vm._s(_vm.$t('Resolve')) + "\n         ")]) : _vm._e(), _vm._v(" "), _vm.showReopen() ? _c('button', {
    staticClass: "submit",
    on: {
      "click": _vm.reopen
    }
  }, [_c('span', {
    staticClass: "comment_btn_icon"
  }), _vm._v("\n           " + _vm._s(_vm.$t('Reopen')) + "\n         ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "window-dialog-button-close",
    attrs: {
      "icon": "",
      "title": _vm.$t('Close')
    },
    on: {
      "click": _vm.menuClose
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('span', {
    staticClass: "lbl-header-status"
  }, [_vm._v(_vm._s(_vm.$t("Status: ")))]), _vm._v(" "), _c('span', {
    staticClass: "header_status"
  }, [_vm._v(_vm._s(_vm.feedbackHeader && this.feedbackHeader.Resolved ? _vm.$t("Resolved") : _vm.$t("Open")))]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('popup', {
    attrs: {
      "comments": _vm.comments,
      "rights": _vm.rights,
      "actions": _vm.actions,
      "user": _vm.user,
      "resolved": _vm.feedbackHeader && _vm.feedbackHeader.Resolved
    },
    on: {
      "save": _vm.onSave,
      "edit": _vm.onUpdate
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-548c6544_0", {
    source: ".nice-handsome-button{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAghJREFUOI2tlM9L03EYx1/P4yzBw+g4JTzU1w7SIdil4zqqkB2c+QdEIDlYdFsgwuhWB4ce8hoFmuyiXT0ERTCICA9uKixpIh1i6ELZ9nk6zNncL1v5vn0/n+f9+jyfz/d5HqGJBmbWey6VDidE9C5Y0DkLAKjKHkgKs+Sxr3c5Oxs6qvdK/YIXW500seeKBpodVpVz5FQtmo6PLjUHji91Dd7onQcetgPVy4yFTLoQYTlcBtDqxr/AAESY8gZ7585k6MVWJ0Xkdaewulwn0vHRJRmYWe/pLh/uKBoQgaE+Pz5teNqmKjljI5fHDIDvLi/XfCd/MwBw6+oV3jy43VFe9xc/8vnbT4B+9btxrZRGRb4ube1soe4zHhtTsGDHlBYyNKjVor0QoCPQ+R3PkVba6YIkLqcgqf+CnNQMgJikfJglEbkHkNk/4NWn7Gkd3uz3M9TnB+CoWGbt6x7FsjsFlJyxuX/wh62SrBR28de2Kn31h0/f8XgU8tjI5Xny9gs7Pw7bpbrr8uppdjZ0pMLjZiFlZyy+3yb88sM5MHBOoluJ4ePTHvNia/MiTNUG+bqEUtka3Y1KpOMjEaiZNpl0IWLGQm3UX8Lm0puFaPWjYQoMPl0Ng7wA+ttzbNc5iW49G1mpXW06Vq5Pv7usfjcONmZo0ByVbhKXE5OUqSTJy8pWYvi43vsbbATCkVijMwoAAAAASUVORK5CYII=);width:20px;height:21px;outline:0;background-color:transparent;border:0;background-repeat:no-repeat;cursor:pointer}.badge{padding-left:9px;padding-right:9px;-webkit-border-radius:9px;-moz-border-radius:9px;border-radius:9px}.badge-warning[href],.label-warning[href]{background-color:#c67605}.feedback-container{height:395px;width:525px}.message_count{font-size:12px;background:red;color:#fff;padding:0 5px;vertical-align:top;margin-left:20px;position:absolute;margin-top:-20px}.message_count2{font-size:12px;background:#19719e;color:#fff;padding:0 5px;vertical-align:top;margin-left:20px;position:absolute;margin-top:-20px}.lbl-header-status{font-size:13px!important;font-weight:700;padding-left:8px;color:#4d4d4d;font-family:Arial!important}.header_status{font-size:14px!important;color:#0070a3;font-family:Arial!important}.hidden-warning{display:none!important}.btn-message{background:0 0!important}.btn-message::before{background:0 0!important}.btn-message .v-btn__content .v-icon{font-size:19px!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

var comment = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, browser, undefined);

var index = {
  install: function install(Vue, options) {
    Vue.component("commentbutton", comment);
  }
};

module.exports = index;
